import React from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Select } from "components"
import classes from "./RrhBranchSelect.module.scss"

const RrhBranchSelect = props => {
  const { filter, setFilter } = props

  const [t, i18n] = useTranslation()

  const cashierBranches =
    useSelector(state => state.userAccountInfo.cashierBranches)

  const handleChangeBranch = (select) => {
    setFilter(prev => ({
      ...prev,
      branchId: select?.value || ""
    }))
  }

  const systemBranchesOptions =
    cashierBranches.map(cashierBranch => ({
      label: `${cashierBranch.name} ${cashierBranch.isOnline ? `(${t("آنلاین")})` : ""}`,
      value: cashierBranch._id
    }))

  const branchSelectValue =
    systemBranchesOptions.find(option =>
      option.value === filter.branchId
    )
    ||
    null

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Select
      isClearable
      label={t("شعبه")}
      noOptionsMessage={() => null}
      options={systemBranchesOptions}
      value={branchSelectValue}
      onChange={handleChangeBranch}
      className={clsx(
        classes["input"],
        isLtr && classes["input-ltr"]
      )}
    />
  )
}

export default RrhBranchSelect